import React, { useCallback } from 'react';
import { LFC } from '../../../Legacy';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';

export const UpgradeMeetingControlsView: LFC<{ onAction: (upgrade?: boolean) => void }> = ({ onAction }) => {

    const onUpgrade = useCallback(() => {
        window.open('/pricing', '_blank');
    }, []);

    return <Flexer inset padding="1" flex="column" center gap=".5">
        <Flexer flex="row" center>
            <Flexer flex="row" center gap=".5" background={Colors.hover} borderRadius={1} padding=".5">
                <Icon size="2" src="deqo://icons/meeting/activity" />
                <Icon size="2" src="deqo://icons/meeting/facilitator" />
                <Icon size="2" src="deqo://icons/meeting/poll" />
                <Icon size="2" src="deqo://icons/meeting/private" />
                <Icon size="2" src="deqo://icons/meeting/ready" />
                <Icon size="2" src="deqo://icons/meeting/anonymous" />
                <Icon size="2" src="deqo://icons/meeting/timer" />
            </Flexer>
        </Flexer>
        <Flexer flex="column" center padding="1" gap=".5">
            <Title flush>Want to run the best meeting ever?</Title>
            <Copy>
                <p>Upgrade today and get access all the meeting controls.</p>
            </Copy>
        </Flexer>
        <Flexer flex="row" gap=".5" center>
            <DropButton padding=".25 .75" overflow=".25" onClick={() => onAction(false)}>
                <Icon src="deqo://icons/hero/arrow-sm-left" size="1.5" />
                <Title weight="450" flush>Go Back</Title>
            </DropButton>
            <DropButton padding=".25 .75" overflow=".25" onClick={() => onUpgrade()}>
                <Icon src="deqo://icons/i8/diamond" size="1.5" />
                <Title weight="450" flush>Upgrade</Title>
            </DropButton>
        </Flexer>
    </Flexer>;
};
